export const profileData = {
  name: 'ERIEL MIQUILINO',
  title: 'PRINCIPAL SOFTWARE ENGINEER',
  tagline: 'Bridging enterprise complexity with elegant cloud-native solutions.Architecting the digital frontier, one system at a time.',
  bio: 'Specialized in architecting high-scale distributed systems and modernizing legacy infrastructures. Currently leading logistics solutions at NDD, leveraging 10+ years of experience in .NET, Azure, and AI-driven automation to build the future of enterprise software.',
};

export const navItems = [
  { id: 'hero', label: 'START' },
  { id: 'projects', label: 'SELECT' },
  { id: 'scores', label: 'SCORES' },
  { id: 'content', label: 'SCREENS' },
];

export const projects = [
  {
    id: 1,
    title: 'filipeborges.me',
    subtitle: 'Personal Brand Experience',
    description: 'A high-performance landing page featuring custom bio storytelling, developed with a focus on seamless transitions and modern UI/UX principles.',
    techStack: ['Next.js', 'React', 'Vercel', 'Tailwind CSS'],
    type: 'creative',
    color: '#00f0ff',
    year: '2024',
    role: 'Full Stack Designer',
  },
  {
    id: 2,
    title: 'Affection Consultoria',
    subtitle: 'Institutional Business Hub',
    description: 'Corporate platform integrated with Sanity CMS for dynamic content management, bridging the gap between bespoke design and scalable architecture.',
    techStack: ['Next.js', 'Sanity.io', 'TypeScript', 'Vercel'],
    type: 'creative',
    color: '#7000ff',
    year: '2024',
    role: 'Lead Developer & Designer',
  },
  {
    id: 3,
    title: 'TL Agro',
    subtitle: 'Agribusiness Digital Catalog',
    description: 'E-commerce hybrid solution featuring a specialized product catalog with WhatsApp checkout integration, built on a custom Underscore WordPress backbone.',
    techStack: ['WordPress', 'PHP', 'Underscore', 'MySQL'],
    type: 'heavy',
    color: '#39ff14',
    year: '2023',
    role: 'Backend Architect',
  },
  {
    id: 4,
    title: 'Axios SaaS',
    subtitle: 'Enterprise Service Management',
    description: 'A comprehensive Service Order and Financial management SaaS. Featuring a Java-based backend engine and a Sanity-driven Next.js frontend for high-scale operations.',
    techStack: ['Java', 'Angular', 'Next.js', 'MySQL', 'Asaas API'],
    type: 'heavy',
    color: '#ff0055',
    year: '2025',
    role: 'Lead Architect',
  },
  {
    id: 5,
    title: 'Julius Finanças',
    subtitle: 'AI-Powered Financial Ecosystem',
    description: 'Personal R&D playground for AI code generation. Integrates Telegram bots with Google Gemini to automate expense tracking and financial forecasting.',
    techStack: ['.NET', 'PostgreSQL', 'Angular', 'Gemini AI', 'Telegram API'],
    type: 'heavy',
    color: '#f0ff00',
    year: '2025',
    role: 'Innovation Lead',
  },
  {
    id: 6,
    title: 'Aurio Reader',
    subtitle: 'Neural Accessibility Tool',
    description: 'Chrome extension leveraging Azure Neural TTS for real-time web page narration, transforming visual content into high-fidelity audio experiences.',
    techStack: ['JavaScript', 'Azure Cognitive Services', 'Chrome API'],
    type: 'creative',
    color: '#0066ff',
    year: '2024',
    role: 'UX & AI Engineer',
  },
  {
    id: 7,
    title: 'Luz do Mundo',
    subtitle: 'Dynamic Retail Catalog',
    description: 'An optimized e-commerce catalog featuring WhatsApp-integrated checkout. Built on a customized PHP framework for high-speed product browsing.',
    techStack: ['WordPress', 'PHP', 'Astra Framework', 'MySQL'],
    type: 'creative',
    color: '#ffd700',
    year: '2024',
    role: 'Full Stack Developer',
  },
  {
    id: 8,
    title: 'GoogleDrivePdfUploader',
    subtitle: 'Serverless Automation Engine',
    description: 'Robust Azure Function developed in .NET for high-volume automated file processing, fetching public PDFs and synchronizing with Google Drive via OAuth.',
    techStack: ['.NET', 'Azure Functions', 'Google Drive API', 'C#'],
    type: 'heavy',
    color: '#00c3ff',
    year: '2025',
    role: 'Cloud Architect',
  }
];

export const skills = [
  { name: 'SYSTEM DESIGN', score: 98500, rank: 1, category: 'ARCH' },
  { name: 'DOTNET / C#', score: 96800, rank: 2, category: 'BE' },
  { name: 'CLOUD ARCHITECTURE', score: 94200, rank: 3, category: 'OPS' },
  { name: 'MICROSERVICES', score: 92100, rank: 4, category: 'ARCH' },
  { name: 'REACT / NEXT.JS', score: 89500, rank: 5, category: 'FE' },
  { name: 'AI / LLM INTEGRATION', score: 87300, rank: 6, category: 'DATA' },
  { name: 'SQL SERVER / POSTGRES', score: 85400, rank: 7, category: 'DATA' },
  { name: 'KUBERNETES / AKS', score: 83600, rank: 8, category: 'OPS' },
  { name: 'MESSAGING / RABBITMQ', score: 81200, rank: 9, category: 'ARCH' },
  { name: 'ANGULAR', score: 79800, rank: 10, category: 'FE' },
];

export const experience = [
  {
    role: 'Software Architect',
    company: 'NDD Tech | Brasil',
    period: '2024 - PRESENT',
    level: 'LVL 99',
    description: 'Orchestrating the evolution of logistics systems through cloud-native architectures. Leading legacy-to-modern migrations using Azure, AKS, and RabbitMQ while defining strategic technical standards for scalable distributed systems.',
  },
  {
    role: 'Software Developer',
    company: 'NDD Tech | Brasil',
    period: '2019 - 2024',
    level: 'LVL 80',
    description: 'Engineered high-availability distributed systems using .NET and NServiceBus. Implemented DDD and TDD patterns across monolithic and microservices environments, streamlining CI/CD pipelines for production stability.',
  },
  {
    role: 'Software Developer',
    company: 'HSI Automação Comercial',
    period: '2016 - 2019',
    level: 'LVL 50',
    description: 'Pioneered a department for electronic invoicing (NF-e) solutions using Java/JSF. Spearheaded innovative restaurant automation projects utilizing Spring Boot, Angular, and NoSQL databases.',
  },
  {
    role: 'System Support Analyst',
    company: 'HSI Automação Comercial',
    period: '2014 - 2016',
    level: 'LVL 25',
    description: 'Optimized ERP/POS operations and fiscal compliance for retail chains. Performed advanced database maintenance and optimization across MySQL, SQL Server, and PostgreSQL environments.',
  },
];

export const contentItems = [
  {
    id: 1,
    type: 'video',
    title: 'Scaling Microservices to 10M Users',
    platform: 'YouTube',
    color: '#ff2d7b',
    size: 'large',
  },
  {
    id: 2,
    type: 'article',
    title: 'The Art of System Design Interviews',
    platform: 'Medium',
    color: '#00f0ff',
    size: 'small',
  },
  {
    id: 3,
    type: 'article',
    title: 'Event-Driven Architecture: A Deep Dive',
    platform: 'Dev.to',
    color: '#a855f7',
    size: 'tall',
  },
  {
    id: 4,
    type: 'video',
    title: 'Building Cloud-Native Apps with Azure',
    platform: 'YouTube',
    color: '#ff00aa',
    size: 'small',
  },
  {
    id: 5,
    type: 'article',
    title: 'Domain-Driven Design in Practice',
    platform: 'Blog',
    color: '#00ff41',
    size: 'wide',
  },
  {
    id: 6,
    type: 'talk',
    title: 'Keynote: Future of Distributed Systems',
    platform: 'Conference',
    color: '#f59e0b',
    size: 'small',
  },
];

export const socialLinks = [
  { label: 'GitHub', url: 'https://github.com/erielmiquilino' },
  { label: 'LinkedIn', url: 'https://www.linkedin.com/in/eriel-miquilino-430536b0/' },
  { label: 'X', url: 'https://x.com/TiuMiquilino' },
];
